// API Configuration
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Welcome backgrounds
export const WELCOME_BACKGROUNDS = [
  "https://images.unsplash.com/photo-1769117320704-b4d7d21ada85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxoYXBweSUyMHBldHMlMjBkb2dzJTIwY2F0cyUyMGNvbG9yZnVsJTIwam95ZnVsfGVufDB8fHx8MTc3MjM5ODM4M3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1509205477838-a534e43a849f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxoYXBweSUyMHBldHMlMjBkb2dzJTIwY2F0cyUyMGNvbG9yZnVsJTIwam95ZnVsfGVufDB8fHx8MTc3MjM5ODM4M3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1618118968094-2fcd4df5d101?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHx3YXRlcmNvbG9yJTIwZmxvd2VycyUyMHNwcmluZyUyMHBhc3RlbCUyMHNvZnR8ZW58MHx8fHwxNzcyMzk4Mzg0fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1559836199-4ac20009a8a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxoYXBweSUyMHBldHMlMjBkb2dzJTIwY2F0cyUyMGNvbG9yZnVsJTIwam95ZnVsfGVufDB8fHx8MTc3MjM5ODM4M3ww&ixlib=rb-4.1.0&q=85"
];

// Mood data
export const MOODS = [
  { emoji: "😊", name: "Happy", background: "https://images.unsplash.com/photo-1681763363228-dd5bc9c37d28?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-yellow-500/20 to-orange-400/30" },
  { emoji: "😌", name: "Peaceful", background: "https://images.unsplash.com/photo-1592976370975-dcc9e764374f?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-purple-500/20 to-pink-400/20" },
  { emoji: "🥰", name: "Loving", background: "https://images.unsplash.com/photo-1761166478784-dc565cffb472?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-pink-400/20 to-rose-300/30" },
  { emoji: "😴", name: "Cozy", background: "https://images.unsplash.com/photo-1767114210435-8122d97c95f8?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-amber-600/30 to-orange-500/30" },
  { emoji: "🤗", name: "Grateful", background: "https://images.unsplash.com/photo-1662359589930-bb721b78edba?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-amber-400/20 to-yellow-500/20" },
  { emoji: "🏖️", name: "Relaxed", background: "https://images.unsplash.com/photo-1683514261963-2c6db08a72fe?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-cyan-400/20 to-blue-400/20" },
  { emoji: "⚡", name: "Energetic", background: "https://images.unsplash.com/photo-1596769016576-166156a7afc9?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-orange-400/20 to-red-400/20" },
  { emoji: "🎉", name: "Playful", background: "https://images.unsplash.com/photo-1729608629987-510b57954c75?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-violet-400/30 to-fuchsia-400/30" },
  { emoji: "🌸", name: "Gentle", background: "https://images.unsplash.com/photo-1761332888266-a3ed50de3c58?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-green-300/20 to-emerald-400/20" },
  { emoji: "🌙", name: "Dreamy", background: "https://images.unsplash.com/photo-1755875479709-4698b71ec494?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-indigo-400/20 to-purple-400/20" },
  { emoji: "🐾", name: "Pawsitive", background: "https://images.unsplash.com/photo-1623945514418-15427b33a34c?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-lime-400/20 to-green-400/20" },
  { emoji: "🎵", name: "Musical", background: "https://images.unsplash.com/photo-1723018623131-03c1d20ac673?crop=entropy&cs=srgb&fm=jpg&w=800", overlay: "from-slate-400/20 to-stone-400/20" },
];

// Daily inspiration quotes
export const DAILY_QUOTES = [
  { quote: "The world would be a nicer place if everyone had the ability to love as unconditionally as a dog.", author: "M.K. Clinton", emoji: "🐕" },
  { quote: "Until one has loved an animal, a part of one's soul remains unawakened.", author: "Anatole France", emoji: "💕" },
  { quote: "Pets are humanizing. They remind us we have an obligation to preserve and nurture.", author: "James Cromwell", emoji: "🌱" },
  { quote: "The smallest feline is a masterpiece.", author: "Leonardo da Vinci", emoji: "🐱" },
  { quote: "Happiness is a warm puppy.", author: "Charles M. Schulz", emoji: "🐾" },
  { quote: "Animals are such agreeable friends—they ask no questions; they pass no criticisms.", author: "George Eliot", emoji: "🤗" },
  { quote: "Time spent with cats is never wasted.", author: "Sigmund Freud", emoji: "😺" },
  { quote: "Dogs do speak, but only to those who know how to listen.", author: "Orhan Pamuk", emoji: "👂" },
  { quote: "The purity of a person's heart can be quickly measured by how they regard animals.", author: "Anonymous", emoji: "❤️" },
  { quote: "What we have once enjoyed we can never lose. All that we love deeply becomes a part of us.", author: "Helen Keller", emoji: "🌟" },
  { quote: "No matter how little money and how few possessions you own, having a dog makes you rich.", author: "Louis Sabin", emoji: "💎" },
  { quote: "A house is not a home without a pet.", author: "Anonymous", emoji: "🏠" },
  { quote: "Pets leave paw prints on your heart.", author: "Anonymous", emoji: "🐾" },
  { quote: "In the eyes of an animal, you are their whole world.", author: "Anonymous", emoji: "🌍" },
  { quote: "The journey of life is sweeter when traveled with a pet.", author: "Anonymous", emoji: "🛤️" },
  { quote: "Every day is a gift—unwrap it with your furry friend.", author: "Anonymous", emoji: "🎁" },
  { quote: "Love is a four-legged word.", author: "Anonymous", emoji: "💝" },
  { quote: "Kindness to all living things is the true religion.", author: "Buddha", emoji: "☮️" },
  { quote: "The greatness of a nation can be judged by the way its animals are treated.", author: "Mahatma Gandhi", emoji: "🕊️" },
  { quote: "One small positive thought in the morning can change your whole day.", author: "Dalai Lama", emoji: "☀️" },
  { quote: "Be the person your pet thinks you are.", author: "Anonymous", emoji: "⭐" },
  { quote: "Every moment matters, especially the quiet ones with those we love.", author: "Anonymous", emoji: "🌸" },
  { quote: "Gratitude turns what we have into enough.", author: "Anonymous", emoji: "🙏" },
  { quote: "Let today be the day you spread joy like your pet spreads fur.", author: "Anonymous", emoji: "😄" },
  { quote: "In a world where you can be anything, be kind—like your pet.", author: "Anonymous", emoji: "💫" },
  { quote: "The best therapist has fur and four legs.", author: "Anonymous", emoji: "🛋️" },
  { quote: "Life is better with paw prints on the floor.", author: "Anonymous", emoji: "🐕‍🦺" },
  { quote: "Take time to pause and appreciate the small moments today.", author: "Anonymous", emoji: "⏸️" },
  { quote: "Your pet doesn't care about your past—they love who you are right now.", author: "Anonymous", emoji: "💖" },
  { quote: "May your day be filled with wagging tails and purring hearts.", author: "Anonymous", emoji: "🎶" }
];

export const GRATITUDE_PROMPTS = [
  "What made you smile today with your pet?",
  "What's something your pet did that warmed your heart?",
  "What are you thankful for about your furry friend?",
  "What special moment did you share with your pet today?",
  "What do you love most about your pet right now?",
  "How did your pet bring you joy today?",
  "What's a small blessing your pet gave you today?",
  "What comfort did your pet bring you when you needed it?",
  "What funny thing did your pet do recently?",
  "How has your pet helped you feel less alone?",
  "What adventure did you share with your pet?",
  "What makes your bond with your pet special?",
  "How did cuddling with your pet make you feel?",
  "What lesson has your pet taught you about life?",
  "What's the sweetest thing your pet does for you?"
];

// Why pets matter
export const WHY_PETS_MATTER = [
  { lesson: "Being present", description: "They don't dwell on yesterday or worry about tomorrow" },
  { lesson: "Forgiving quickly", description: "A moment later, all is forgotten and love remains" },
  { lesson: "Noticing small joys", description: "A sunbeam, a treat, your return home — all miracles" },
  { lesson: "Loving without keeping score", description: "Their love is unconditional and infinite" }
];

// How to show love tips
export const SHOW_LOVE_TIPS = [
  { tip: "\"Hello\" Ritual", description: "A calm greeting with a gentle touch when you see them", emoji: "👋" },
  { tip: "5 Minutes of Focus", description: "Put the phone down. Just play. Just be together.", emoji: "🎯" },
  { tip: "Create a Cozy Spot", description: "A safe blanket, bed, or corner that's just theirs", emoji: "🛏️" },
  { tip: "Use Your Soft Voice", description: "Pets understand tone — let yours say \"I love you\"", emoji: "💬" },
  { tip: "Slow Walks or Porch Time", description: "Let them sniff, explore, and take their time", emoji: "🚶" },
  { tip: "Little Training with Praise", description: "Builds confidence and deepens trust", emoji: "⭐" },
  { tip: "Calm-Down Routine", description: "Music + breathing + gentle petting = peace", emoji: "🎵" },
  { tip: "Health Check Habit", description: "Fresh water, clean bowls, a gentle body check", emoji: "💧" },
  { tip: "Gratitude Out Loud", description: "Say it: \"I'm so glad you're here.\"", emoji: "🙏" }
];

// Breathing exercises
export const BREATHING_EXERCISES = [
  {
    name: "4-7-8 Calming Breath",
    description: "A relaxing technique to calm your nervous system",
    steps: ["Breathe in through your nose for 4 seconds", "Hold your breath for 7 seconds", "Exhale slowly through your mouth for 8 seconds", "Repeat 3-4 times"],
    duration: "2-3 minutes",
    emoji: "🌬️"
  },
  {
    name: "Box Breathing",
    description: "Used by Navy SEALs to stay calm under pressure",
    steps: ["Inhale for 4 seconds", "Hold for 4 seconds", "Exhale for 4 seconds", "Hold for 4 seconds", "Repeat 4 times"],
    duration: "2 minutes",
    emoji: "📦"
  },
  {
    name: "Pet Cuddle Breathing",
    description: "Sync your breathing with your pet's calm presence",
    steps: ["Hold or sit near your pet", "Place your hand on their chest", "Match your breathing to their rhythm", "Feel your heartbeats sync together"],
    duration: "5 minutes",
    emoji: "🐾"
  },
  {
    name: "Morning Sunshine Breath",
    description: "Energize your morning with your pet",
    steps: ["Stand or sit with your pet nearby", "Inhale deeply, raising arms overhead", "Exhale, lowering arms and petting your companion", "Smile and repeat 5 times"],
    duration: "2 minutes",
    emoji: "☀️"
  },
  {
    name: "Evening Wind-Down",
    description: "Prepare for restful sleep with your pet",
    steps: ["Dim the lights and get cozy with your pet", "Take 10 slow, deep breaths", "With each exhale, release the day's stress", "Focus on the warmth of your pet beside you"],
    duration: "5 minutes",
    emoji: "🌙"
  }
];

export const RELAXATION_TIPS = [
  { emoji: "🎵", tip: "Play calming music for you and your pet - classical or nature sounds work wonderfully" },
  { emoji: "🌿", tip: "Take a gentle walk in nature with your pet - fresh air heals the soul" },
  { emoji: "☕", tip: "Enjoy a warm cup of tea while your pet rests beside you" },
  { emoji: "📖", tip: "Read aloud to your pet - they love the sound of your voice" },
  { emoji: "🧘", tip: "Practice gentle stretches while your pet watches or joins in" },
  { emoji: "🌸", tip: "Create a cozy corner with soft blankets for you and your pet" },
  { emoji: "💆", tip: "Give your pet a gentle massage - it relaxes both of you" },
  { emoji: "🎨", tip: "Do a calming activity like coloring while your pet naps nearby" }
];

// Guided Journal Prompts - "Lantern" themed gentle reflections
// Designed for both current pets and remembered ones
export const GUIDED_JOURNAL_PROMPTS = [
  {
    id: "first-hello",
    title: "The First Hello",
    icon: "🌟",
    description: "The moment you first met",
    prompt: "Describe the very first time you met your pet. What did you notice? What did they do? How did it feel?",
    color: "from-amber-100 to-yellow-50",
    borderColor: "border-amber-200"
  },
  {
    id: "everyday-magic",
    title: "Little Everyday Magic",
    icon: "✨",
    description: "The small treasures of daily life",
    prompt: "What's something ordinary your pet does that brings you unexpected joy? A little habit, a look, a sound?",
    color: "from-rose-100 to-pink-50",
    borderColor: "border-rose-200"
  },
  {
    id: "if-they-could-talk",
    title: "If They Could Talk...",
    icon: "💬",
    description: "Imagined conversations",
    prompt: "If your pet could speak for one minute, what do you think they would tell you? What would you say back?",
    color: "from-sky-100 to-blue-50",
    borderColor: "border-sky-200"
  },
  {
    id: "comfort-moments",
    title: "Comfort in Their Presence",
    icon: "🤗",
    description: "When they made everything better",
    prompt: "Think of a time when your pet's presence brought you comfort or peace. What was happening, and how did they help?",
    color: "from-purple-100 to-violet-50",
    borderColor: "border-purple-200"
  },
  {
    id: "funny-memory",
    title: "That Time They Made You Laugh",
    icon: "😄",
    description: "A moment of joy and silliness",
    prompt: "What's a funny or silly memory with your pet that still makes you smile?",
    color: "from-orange-100 to-amber-50",
    borderColor: "border-orange-200"
  },
  {
    id: "lessons-learned",
    title: "What They Teach Me",
    icon: "💡",
    description: "Wisdom from our companions",
    prompt: "What has your pet taught you about life, love, patience, or joy? How have they changed you?",
    color: "from-teal-100 to-emerald-50",
    borderColor: "border-teal-200"
  },
  {
    id: "favorite-spot",
    title: "Their Special Place",
    icon: "🏡",
    description: "Where they feel most at home",
    prompt: "Where does your pet love to be? Describe their favorite spot and what makes it special.",
    color: "from-lime-100 to-green-50",
    borderColor: "border-lime-200"
  },
  {
    id: "gratitude-today",
    title: "Thankful for Today",
    icon: "🙏",
    description: "A moment of appreciation",
    prompt: "What are you most grateful for about your pet today, or about your time together?",
    color: "from-indigo-100 to-blue-50",
    borderColor: "border-indigo-200"
  },
  {
    id: "adventure-together",
    title: "Our Adventure",
    icon: "🌈",
    description: "A special journey or outing",
    prompt: "Describe an adventure or special outing you shared. It could be big or small - what made it memorable?",
    color: "from-fuchsia-100 to-pink-50",
    borderColor: "border-fuchsia-200"
  },
  {
    id: "still-with-me",
    title: "Still With Me",
    icon: "🕯️",
    description: "For pets we carry in our hearts",
    prompt: "Write about how your pet's spirit stays with you. A habit they left behind, a feeling you have, or how you honor their memory.",
    color: "from-slate-100 to-gray-50",
    borderColor: "border-slate-300"
  },
  {
    id: "letter-to-pet",
    title: "A Letter to My Pet",
    icon: "💌",
    description: "Words from your heart",
    prompt: "Write a short letter to your pet. What would you like to tell them?",
    color: "from-red-100 to-rose-50",
    borderColor: "border-red-200"
  },
  {
    id: "perfect-day",
    title: "A Perfect Day Together",
    icon: "☀️",
    description: "Dream or real - a day of joy",
    prompt: "Describe a perfect day with your pet - real or imagined. What would you do together?",
    color: "from-yellow-100 to-amber-50",
    borderColor: "border-yellow-200"
  }
];
